export default __webpack_public_path__ + "static/media/icon_align_large_off.186de690.svg";